/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomRecurrenceRuleResponse
 */
export interface CustomRecurrenceRuleResponse {
    /**
     * Days of week (0=Sunday, 6=Saturday)
     * @type {Array<number>}
     * @memberof CustomRecurrenceRuleResponse
     */
    daysOfWeek: Array<number>;
    /**
     * 24-hour time, "HH:mm" (e.g., "17:00" for 5 PM)
     * @type {string}
     * @memberof CustomRecurrenceRuleResponse
     */
    startTimeOfDay: string;
    /**
     * How long each occurrence runs (e.g., 120 for 2 hours)
     * @type {number}
     * @memberof CustomRecurrenceRuleResponse
     */
    durationMinutes: number;
    /**
     * IANA timezone (e.g., "America/New_York")
     * @type {string}
     * @memberof CustomRecurrenceRuleResponse
     */
    timezone: string;
}

/**
 * Check if a given object implements the CustomRecurrenceRuleResponse interface.
 */
export function instanceOfCustomRecurrenceRuleResponse(value: object): value is CustomRecurrenceRuleResponse {
    if (!('daysOfWeek' in value) || value['daysOfWeek'] === undefined) return false;
    if (!('startTimeOfDay' in value) || value['startTimeOfDay'] === undefined) return false;
    if (!('durationMinutes' in value) || value['durationMinutes'] === undefined) return false;
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    return true;
}

export function CustomRecurrenceRuleResponseFromJSON(json: any): CustomRecurrenceRuleResponse {
    return CustomRecurrenceRuleResponseFromJSONTyped(json, false);
}

export function CustomRecurrenceRuleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomRecurrenceRuleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'daysOfWeek': json['daysOfWeek'],
        'startTimeOfDay': json['startTimeOfDay'],
        'durationMinutes': json['durationMinutes'],
        'timezone': json['timezone'],
    };
}

export function CustomRecurrenceRuleResponseToJSON(json: any): CustomRecurrenceRuleResponse {
    return CustomRecurrenceRuleResponseToJSONTyped(json, false);
}

export function CustomRecurrenceRuleResponseToJSONTyped(value?: CustomRecurrenceRuleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'daysOfWeek': value['daysOfWeek'],
        'startTimeOfDay': value['startTimeOfDay'],
        'durationMinutes': value['durationMinutes'],
        'timezone': value['timezone'],
    };
}

